import { attr, belongsTo } from '@ember-data/model';
import { reads } from 'macro-decorators';
import Super from './document-request';

export default class DocumentRequestGoodFaithEstimate extends Super {
  documentIcon = 'file-text';
  mixpanelType = 'Good faith estimate';

  @belongsTo('good-faith-estimate', { async: false, inverse: null }) goodFaithEstimate;
  @belongsTo('good-faith-estimate-overview', { async: false, inverse: null })
  goodFaithEstimateOverview;
  @attr('moment') documentDate;

  @reads('isComplete') hasDocumentPdf;
}
